/*
 * Candles by Midnight — Gift-finder quiz stepper.
 * 4 steps; occasion answer carries a collection handle. Result links to that collection.
 */
if (!customElements.get('gift-quiz')) {
  customElements.define(
    'gift-quiz',
    class GiftQuiz extends HTMLElement {
      connectedCallback() {
        this.base = this.dataset.base || '/collections/';
        this.fallback = this.dataset.fallback || '/collections/all';
        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.total = this.steps.length;
        this.progress = this.querySelector('[data-quiz-progress]');
        this.resultEl = this.querySelector('[data-quiz-result]');
        this.stageEl = this.querySelector('[data-quiz-stage]');
        this.summaryEl = this.querySelector('[data-quiz-summary]');
        this.ctaEl = this.querySelector('[data-quiz-cta]');
        this.backEl = this.querySelector('[data-quiz-back]');
        this.current = 0;
        this.answers = {};
        this.collection = null;

        this.addEventListener('click', (e) => {
          const opt = e.target.closest('[data-key]');
          if (opt) return this.choose(opt);
          if (e.target.closest('[data-quiz-restart]')) return this.restart();
          if (e.target.closest('[data-quiz-back]')) return this.back();
        });
        this.render();
      }

      choose(opt) {
        const step = opt.closest('[data-step]');
        step.querySelectorAll('.giftquiz__opt--selected').forEach((b) => b.classList.remove('giftquiz__opt--selected'));
        opt.classList.add('giftquiz__opt--selected');
        this.answers[opt.dataset.key] = opt.dataset.value;
        if (opt.dataset.collection) this.collection = opt.dataset.collection;
        window.setTimeout(() => {
          if (this.current < this.total - 1) { this.current += 1; this.render(); }
          else this.finish();
        }, 220);
      }

      back() {
        if (this.current > 0) { this.current -= 1; this.render(); }
      }

      render() {
        this.steps.forEach((s, i) => { s.hidden = i !== this.current; });
        if (this.progress) this.progress.style.width = ((this.current + 1) / this.total) * 100 + '%';
        if (this.backEl) this.backEl.hidden = this.current === 0;
      }

      finish() {
        const handle = this.collection || 'all';
        const url = handle === 'all' && this.fallback ? this.fallback : this.base + handle;
        const a = this.answers;
        const who = a.who ? (a.who === 'Myself' ? 'yourself' : 'your ' + a.who.toLowerCase()) : 'someone special';
        const bits = [];
        if (a.occasion) bits.push(a.occasion.toLowerCase());
        if (a.vibe) bits.push('a ' + a.vibe.toLowerCase() + ' vibe');
        if (a.budget) bits.push(a.budget);
        if (this.summaryEl) this.summaryEl.textContent = 'For ' + who + ' — ' + (bits.join(', ') || 'a thoughtful gift') + '. Here’s your match.';
        if (this.ctaEl) this.ctaEl.setAttribute('href', url);
        if (this.stageEl) this.stageEl.hidden = true;
        if (this.backEl) this.backEl.hidden = true;
        if (this.progress) this.progress.style.width = '100%';
        if (this.resultEl) this.resultEl.hidden = false;
      }

      restart() {
        this.current = 0;
        this.answers = {};
        this.collection = null;
        this.querySelectorAll('.giftquiz__opt--selected').forEach((b) => b.classList.remove('giftquiz__opt--selected'));
        if (this.resultEl) this.resultEl.hidden = true;
        if (this.stageEl) this.stageEl.hidden = false;
        this.render();
      }
    }
  );
}
